import { useState, useEffect, useCallback } from 'react';

/**
 * Fetches a feature's listing data via `config.apis.getAll`. Only runs when
 * `enabled` is true (listing routes). Exposes optimistic setters for use by
 * feature actions (delete/publish).
 */
export function useListingData(config, enabled) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(enabled);

  const fetch = useCallback(async () => {
    if (!config.apis.getAll) return;
    setLoading(true);
    try {
      const result = await config.apis.getAll();
      setData(Array.isArray(result) ? result : []);
    } catch {
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [config.apis]);

  useEffect(() => {
    if (enabled) {
      fetch();
    } else {
      // Leaving the listing (e.g. navigating to builder) — drop the
      // cached rows so the shimmer shows cleanly on return instead of
      // flashing stale data while the refetch is in flight.
      setData([]);
    }
  }, [enabled, fetch]);

  return { data, setData, loading, setLoading, refetch: fetch };
}
